import {
  ExtendedTypography,
  ExtendedTypographyProps
} from "../ExtendedTypography";
export const Typography = ExtendedTypography;
export interface TypographyProps extends ExtendedTypographyProps {}
